export type ExpenseCategory = 
  | 'advertising'
  | 'vehicle'
  | 'commissions'
  | 'contract-labor'
  | 'depreciation'
  | 'insurance'
  | 'interest'
  | 'legal-professional'
  | 'office-expense'
  | 'rent-lease'
  | 'repairs-maintenance'
  | 'supplies'
  | 'taxes-licenses'
  | 'travel'
  | 'meals'
  | 'utilities'
  | 'home-office'
  | 'other';

export interface Expense {
  id: string;
  date: string;
  amount: number;
  category: ExpenseCategory;
  description: string;
  businessPurpose?: string;
  receiptUrl?: string; // base64 encoded image
  createdAt: string;
  userId?: string; // User email for multi-user support
}

export interface ExpenseStats {
  totalExpenses: number;
  expensesByCategory: Record<ExpenseCategory, number>;
  auditRiskScore: number;
  riskFactors: RiskFactor[];
}

export interface RiskFactor {
  category: string;
  issue: string;
  severity: 'low' | 'medium' | 'high';
  recommendation: string;
}

export const CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  'advertising': 'Advertising & Marketing',
  'vehicle': 'Vehicle Expenses',
  'commissions': 'Commissions & Fees',
  'contract-labor': 'Contract Labor',
  'depreciation': 'Depreciation',
  'insurance': 'Insurance',
  'interest': 'Interest',
  'legal-professional': 'Legal & Professional Services',
  'office-expense': 'Office Expenses',
  'rent-lease': 'Rent or Lease',
  'repairs-maintenance': 'Repairs & Maintenance',
  'supplies': 'Supplies',
  'taxes-licenses': 'Taxes & Licenses',
  'travel': 'Travel',
  'meals': 'Meals & Entertainment',
  'utilities': 'Utilities',
  'home-office': 'Home Office',
  'other': 'Other Expenses'
};

export const CATEGORY_DESCRIPTIONS: Record<ExpenseCategory, string> = {
  'advertising': 'Marketing, ads, website costs',
  'vehicle': 'Mileage, gas, repairs, insurance',
  'commissions': 'Sales commissions, processing fees',
  'contract-labor': 'Payments to contractors (1099)',
  'depreciation': 'Equipment depreciation',
  'insurance': 'Business liability, health insurance',
  'interest': 'Business loan interest',
  'legal-professional': 'Accountant, lawyer, consultant fees',
  'office-expense': 'Software, subscriptions, small equipment',
  'rent-lease': 'Office rent, equipment leases',
  'repairs-maintenance': 'Equipment and property repairs',
  'supplies': 'Office supplies, materials',
  'taxes-licenses': 'Business licenses, property tax',
  'travel': 'Flights, hotels, rental cars',
  'meals': 'Business meals (50% deductible)',
  'utilities': 'Phone, internet, electricity',
  'home-office': 'Home office deduction',
  'other': 'Other business expenses'
};
